// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__1x3Eq","homeFooter":"Layout_homeFooter__4jv_H"};